export const geoDataPA = {
    provinces: [
        {
            id: 0,
            name: "Seleccione Provincia"
        },
        {
            id: 1,
            name: "Bocas del Toro"
        },
        {
            id: 2,
            name: "Chiriquí"
        },
        {
            id: 3,
            name: "Coclé"
        },
        {
            id: 4,
            name: "Colón"
        },
        {
            id: 5,
            name: "Darién"
        },
        {
            id: 6,
            name: "Herrera"
        },
        {
            id: 7,
            name: "Los Santos"
        },
        {
            id: 8,
            name: "Panamá"
        },
        {
            id: 9,
            name: "Panamá Oeste"
        },
        {
            id: 10,
            name: "Veraguas"
        },
        {
            id: 11,
            name: "Guna Yala"
        },
        {
            id: 12,
            name: "Ngöbé-Bugle"
        },
        {
            id: 13,
            name: "Emberá Wounaan"
        }
    ],
    districts: [
        {
            provinceId: 0,
            id: 0,
            name: "Seleccione Distrito",
            code: 0
        },
        {
            provinceId: 1,
            id: 1,
            name: "Almirante",
            code: 101
        },
        {
            provinceId: 1,
            id: 2,
            name: "Bocas del Toro",
            code: 102
        },
        {
            provinceId: 1,
            id: 3,
            name: "Changuinola",
            code: 103
        },
        {
            provinceId: 1,
            id: 4,
            name: "Chiriquí Grande",
            code: 104
        },
        
        
        {
            provinceId: 2,
            id: 1,
            name: "Alanje",
            code: 201
        },
        {
            provinceId: 2,
            id: 2,
            name: "Barú",
            code: 202
        },
        {
            provinceId: 2,
            id: 3,
            name: "Boquerón",
            code: 203
        },
        {
            provinceId: 2,
            id: 4,
            name: "Boquete",
            code: 204
        },
        {
            provinceId: 2,
            id: 5,
            name: "Bugaba",
            code: 205
        },
        {
            provinceId: 2,
            id: 6,
            name: "David",
            code: 206
        },
        {
            provinceId: 2,
            id: 7,
            name: "Dolega",
            code: 207
        },
        {
            provinceId: 2,
            id: 8,
            name: "Gualaca",
            code: 208
        },
        {
            provinceId: 2,
            id: 9,
            name: "Remedios",
            code: 209
        },
        {
            provinceId: 2,
            id: 10,
            name: "Renacimiento",
            code: 210
        },
        {
            provinceId: 2,
            id: 11,
            name: "San Félix",
            code: 211
        },
        {
            provinceId: 2,
            id: 12,
            name: "San Lorenzo",
            code: 212
        },
        {
            provinceId: 2,
            id: 13,
            name: "Tierras Altas",
            code: 213
        },
        {
            provinceId: 2,
            id: 14,
            name: "Tolé",
            code: 214
        },
        
        
        {
            provinceId: 3,
            id: 1,
            name: "Aguadulce",
            code: 301
        },
        {
            provinceId: 3,
            id: 2,
            name: "Antón",
            code: 302
        },
        {
            provinceId: 3,
            id: 3,
            name: "La Pintada",
            code: 303
        },
        {
            provinceId: 3,
            id: 4,
            name: "Natá",
            code: 304
        },
        {
            provinceId: 3,
            id: 5,
            name: "Olá",
            code: 305
        },
        {
            provinceId: 3,
            id: 6,
            name: "Penonomé",
            code: 306
        },
        
        
        {
            provinceId: 4,
            id: 1,
            name: "Chagres",
            code: 401
        },
        {
            provinceId: 4,
            id: 2,
            name: "Colón",
            code: 402
        },
        {
            provinceId: 4,
            id: 3,
            name: "Donoso",
            code: 403
        },
        {
            provinceId: 4,
            id: 4,
            name: "Portobelo",
            code: 404
        },
        {
            provinceId: 4,
            id: 5,
            name: "Santa Isabel",
            code: 405
        },
        {
            provinceId: 4,
            id: 6,
            name: "Omar Torrijos Herrera",
            code: 406
        },
        
        
        {
            provinceId: 5,
            id: 1,
            name: "Chepigana",
            code: 501
        },
        {
            provinceId: 5,
            id: 2,
            name: "Pinogana",
            code: 502
        },
        {
            provinceId: 5,
            id: 3,
            name: "Santa Fe",
            code: 503
        },
        {
            provinceId: 5,
            id: 4,
            name: "Guna de Wargandí",
            code: 504
        },
        
        
        {
            provinceId: 6,
            id: 1,
            name: "Chitré",
            code: 601
        },
        {
            provinceId: 6,
            id: 2,
            name: "Las Minas",
            code: 602
        },
        {
            provinceId: 6,
            id: 3,
            name: "Los Pozos",
            code: 603
        },
        {
            provinceId: 6,
            id: 4,
            name: "Ocú",
            code: 604
        },
        {
            provinceId: 6,
            id: 5,
            name: "Parita",
            code: 605
        },
        {
            provinceId: 6,
            id: 6,
            name: "Pesé",
            code: 606
        },
        {
            provinceId: 6,
            id: 7,
            name: "Santa María",
            code: 607
        },
        
        
        {
            provinceId: 7,
            id: 1,
            name: "Guararé",
            code: 701
        },
        {
            provinceId: 7,
            id: 2,
            name: "Las Tablas",
            code: 702
        },
        {
            provinceId: 7,
            id: 3,
            name: "Los Santos",
            code: 703
        },
        {
            provinceId: 7,
            id: 4,
            name: "Macaracas",
            code: 704
        },
        {
            provinceId: 7,
            id: 5,
            name: "Pedasí",
            code: 705
        },
        {
            provinceId: 7,
            id: 6,
            name: "Pocrí",
            code: 706
        },
        {
            provinceId: 7,
            id: 7,
            name: "Tonosí",
            code: 707
        },
        
        
        {
            provinceId: 8,
            id: 1,
            name: "Balboa",
            code: 801
        },
        {
            provinceId: 8,
            id: 2,
            name: "Chepo",
            code: 802
        },
        {
            provinceId: 8,
            id: 3,
            name: "Chimán",
            code: 803
        },
        {
            provinceId: 8,
            id: 4,
            name: "Guna de Madugandí",
            code: 804
        },
        {
            provinceId: 8,
            id: 5,
            name: "Panamá",
            code: 805
        },
        {
            provinceId: 8,
            id: 6,
            name: "San Miguelito",
            code: 806
        },
        {
            provinceId: 8,
            id: 7,
            name: "Taboga",
            code: 807
        },
        
        
        {
            provinceId: 9,
            id: 1,
            name: "Arraiján",
            code: 901
        },
        {
            provinceId: 9,
            id: 2,
            name: "Capira",
            code: 902
        },
        {
            provinceId: 9,
            id: 3,
            name: "Chame",
            code: 903
        },
        {
            provinceId: 9,
            id: 4,
            name: "La Chorrera",
            code: 904
        },
        {
            provinceId: 9,
            id: 5,
            name: "San Carlos",
            code: 905
        },
        
        
        {
            provinceId: 10,
            id: 1,
            name: "Atalaya",
            code: 1001
        },
        {
            provinceId: 10,
            id: 2,
            name: "Calobre",
            code: 1002
        },
        {
            provinceId: 10,
            id: 3,
            name: "Cañazas",
            code: 1003
        },
        {
            provinceId: 10,
            id: 4,
            name: "La Mesa",
            code: 1004
        },
        {
            provinceId: 10,
            id: 5,
            name: "Las Palmas",
            code: 1005
        },
        {
            provinceId: 10,
            id: 6,
            name: "Mariato",
            code: 1006
        },
        {
            provinceId: 10,
            id: 7,
            name: "Montijo",
            code: 1007
        },
        {
            provinceId: 10,
            id: 8,
            name: "Río de Jesús",
            code: 1008
        },
        {
            provinceId: 10,
            id: 9,
            name: "San Francisco",
            code: 1009
        },
        {
            provinceId: 10,
            id: 10,
            name: "Santa Fe",
            code: 1010
        },
        {
            provinceId: 10,
            id: 11,
            name: "Santiago",
            code: 1011
        },
        {
            provinceId: 10,
            id: 12,
            name: "Soná",
            code: 1012
        },
        
        
        {
            provinceId: 11,
            id: 1,
            name: "Guna Yala",
            code: 1001
        },
        
        
        {
            provinceId: 12,
            id: 1,
            name: "Besikó",
            code: 1201
        },
        {
            provinceId: 12,
            id: 2,
            name: "Jirondai",
            code: 1202
        },
        {
            provinceId: 12,
            id: 3,
            name: "Kankintú",
            code: 1203
        },
        {
            provinceId: 12,
            id: 4,
            name: "Kusapín",
            code: 1204
        },
        {
            provinceId: 12,
            id: 5,
            name: "Mironó",
            code: 1205
        },
        {
            provinceId: 12,
            id: 6,
            name: "Müna",
            code: 1206
        },
        {
            provinceId: 12,
            id: 7,
            name: "Nole Duima",
            code: 1207
        },
        {
            provinceId: 12,
            id: 8,
            name: "Ñürüm",
            code: 1208
        },
        {
            provinceId: 12,
            id: 9,
            name: "Santa Catalina o Calovébora",
            code: 1209
        },
        
        
        {
            provinceId: 13,
            id: 1,
            name: "Cémaco",
            code: 1301
        },
        {
            provinceId: 13,
            id: 2,
            name: "Sambú",
            code: 1302
        },
    ],
    corregimientos: [
        { provinceId: 0, id: 0, name: "Seleccione Corregimiento", code: 0 },

        { provinceId: 1, cantonId: 1, id: 1, code: 10101, name: "Almirante" },
        { provinceId: 1, cantonId: 1, id: 2, code: 10102, name: "Barriada Guaymí" },
        { provinceId: 1, cantonId: 1, id: 3, code: 10103, name: "Barrio Francés" },
        { provinceId: 1, cantonId: 1, id: 4, code: 10104, name: "Nance de Riscó" },
        { provinceId: 1, cantonId: 1, id: 5, code: 10104, name: "Valle de Aguas Arriba" },
        { provinceId: 1, cantonId: 1, id: 6, code: 10106, name: "Valle de Riscó" },

        { provinceId: 1, cantonId: 2, id: 1, code: 10201, name: "Bastimentos" },
        { provinceId: 1, cantonId: 2, id: 2, code: 10202, name: "Bocas del Toro" },
        { provinceId: 1, cantonId: 2, id: 3, code: 10203, name: "Cauchero" },
        { provinceId: 1, cantonId: 2, id: 4, code: 10204, name: "Punta Laurel" },
        { provinceId: 1, cantonId: 2, id: 5, code: 10205, name: "Tierra Oscura" },

        { provinceId: 1, cantonId: 3, id: 1, code: 10301, name: "Changuinola" },
        { provinceId: 1, cantonId: 3, id: 2, code: 10302, name: "Cochigro" },
        { provinceId: 1, cantonId: 3, id: 3, code: 10303, name: "El Empalme" },
        { provinceId: 1, cantonId: 3, id: 4, code: 10304, name: "Guabito" },
        { provinceId: 1, cantonId: 3, id: 5, code: 10305, name: "La Gloria" },
        { provinceId: 1, cantonId: 3, id: 6, code: 10306, name: "Las Delicias" },
        { provinceId: 1, cantonId: 3, id: 7, code: 10307, name: "Las Tablas" },
        { provinceId: 1, cantonId: 3, id: 8, code: 10308, name: "Barriada 4 de Abril" },
        { provinceId: 1, cantonId: 3, id: 9, code: 10309, name: "El Teribe" },
        { provinceId: 1, cantonId: 3, id: 10, code: 103010, name: "Finca 30" },
        { provinceId: 1, cantonId: 3, id: 11, code: 103011, name: "Finca 60" },
        { provinceId: 1, cantonId: 3, id: 12, code: 103012, name: "Finca 6" },
        { provinceId: 1, cantonId: 3, id: 13, code: 103013, name: "El Silencio" },

        { provinceId: 1, cantonId: 4, id: 1, code: 10401, name: "Bajo Cedro" },
        { provinceId: 1, cantonId: 4, id: 2, code: 10402, name: "Chiriquí Grande" },
        { provinceId: 1, cantonId: 4, id: 3, code: 10403, name: "Miramar" },
        { provinceId: 1, cantonId: 4, id: 4, code: 10404, name: "Punta Peña" },
        { provinceId: 1, cantonId: 4, id: 5, code: 10405, name: "Punta Robalo" },
        { provinceId: 1, cantonId: 4, id: 6, code: 10406, name: "Rambala" },

        { provinceId: 2, cantonId: 1, id: 1, code: 20101, name: "Alanje" },
        { provinceId: 2, cantonId: 1, id: 2, code: 20102, name: "Divalá" },
        { provinceId: 2, cantonId: 1, id: 3, code: 20103, name: "Canta Gallo" },
        { provinceId: 2, cantonId: 1, id: 4, code: 20104, name: "El Tejar" },
        { provinceId: 2, cantonId: 1, id: 5, code: 20105, name: "Guarumal" },
        { provinceId: 2, cantonId: 1, id: 6, code: 20106, name: "Nuevo México" },
        { provinceId: 2, cantonId: 1, id: 7, code: 20107, name: "Querévalo" },
        { provinceId: 2, cantonId: 1, id: 8, code: 20108, name: "Palo Grande" },
        { provinceId: 2, cantonId: 1, id: 9, code: 20109, name: "Santo Tomás" },

        { provinceId: 2, cantonId: 2, id: 1, code: 20201, name: "Baco" },
        { provinceId: 2, cantonId: 2, id: 2, code: 20202, name: "Limones" },
        { provinceId: 2, cantonId: 2, id: 3, code: 20203, name: "Progreso" },
        { provinceId: 2, cantonId: 2, id: 4, code: 20204, name: "Puerto Armuelles" },
        { provinceId: 2, cantonId: 2, id: 5, code: 20205, name: "Rodolfo Aguilar Delgado" },

        { provinceId: 2, cantonId: 3, id: 1, code: 20301, name: "Bágala" },
        { provinceId: 2, cantonId: 3, id: 2, code: 20302, name: "Boquerón" },
        { provinceId: 2, cantonId: 3, id: 3, code: 20303, name: "Cordillera" },
        { provinceId: 2, cantonId: 3, id: 4, code: 20304, name: "Guabal" },
        { provinceId: 2, cantonId: 3, id: 5, code: 20305, name: "Guayabal" },
        { provinceId: 2, cantonId: 3, id: 6, code: 20306, name: "Paraíso" },
        { provinceId: 2, cantonId: 3, id: 7, code: 20307, name: "Pedregal" },
        { provinceId: 2, cantonId: 3, id: 8, code: 20308, name: "Tijeras" },

        { provinceId: 2, cantonId: 4, id: 1, code: 20401, name: "Alto Boquete" },
        { provinceId: 2, cantonId: 4, id: 2, code: 20402, name: "Bajo Boquete" },
        { provinceId: 2, cantonId: 4, id: 3, code: 20403, name: "Caldera" },
        { provinceId: 2, cantonId: 4, id: 4, code: 20404, name: "Jaramillo" },
        { provinceId: 2, cantonId: 4, id: 5, code: 20405, name: "Los Naranjos" },
        { provinceId: 2, cantonId: 4, id: 6, code: 20406, name: "Palmira" },

        { provinceId: 2, cantonId: 5, id: 1, code: 20501, name: "Aserrío de Gariché" },
        { provinceId: 2, cantonId: 5, id: 2, code: 20504, name: "Bugaba" },
        { provinceId: 2, cantonId: 5, id: 3, code: 20503, name: "El Bongo" },
        { provinceId: 2, cantonId: 5, id: 4, code: 20504, name: "Gómez" },
        { provinceId: 2, cantonId: 5, id: 5, code: 20505, name: "La Concepción" },
        { provinceId: 2, cantonId: 5, id: 6, code: 20506, name: "La Estrella" },
        { provinceId: 2, cantonId: 5, id: 7, code: 20507, name: "San Andrés" },
        { provinceId: 2, cantonId: 5, id: 8, code: 20508, name: "Santa Marta" },
        { provinceId: 2, cantonId: 5, id: 9, code: 20509, name: "Santa Rosa" },
        { provinceId: 2, cantonId: 5, id: 10, code: 205010, name: "Santo Domingo" },
        { provinceId: 2, cantonId: 5, id: 11, code: 205011, name: "Sortová" },
        { provinceId: 2, cantonId: 5, id: 12, code: 205012, name: "Solano" },
        { provinceId: 2, cantonId: 5, id: 13, code: 205013, name: "San Isidro" },

        { provinceId: 2, cantonId: 6, id: 1, code: 20601, name: "Bijagual" },
        { provinceId: 2, cantonId: 6, id: 2, code: 20602, name: "Cochea" },
        { provinceId: 2, cantonId: 6, id: 3, code: 20603, name: "Chiriquí" },
        { provinceId: 2, cantonId: 6, id: 4, code: 20604, name: "Guacá" },
        { provinceId: 2, cantonId: 6, id: 5, code: 20605, name: "Las Lomas" },
        { provinceId: 2, cantonId: 6, id: 6, code: 20606, name: "Pedregal" },
        { provinceId: 2, cantonId: 6, id: 7, code: 20607, name: "San Carlos" },
        { provinceId: 2, cantonId: 6, id: 8, code: 20608, name: "David" },
        { provinceId: 2, cantonId: 6, id: 9, code: 20609, name: "David Este" },
        { provinceId: 2, cantonId: 6, id: 10, code: 206010, name: "David Sur" },
        { provinceId: 2, cantonId: 6, id: 11, code: 206011, name: "San Pablo Nuevo" },
        { provinceId: 2, cantonId: 6, id: 12, code: 206012, name: "San Pablo Viejo" },

        { provinceId: 2, cantonId: 7, id: 1, code: 20701, name: "Dolega" },
        { provinceId: 2, cantonId: 7, id: 2, code: 20702, name: "Dos Ríos" },
        { provinceId: 2, cantonId: 7, id: 3, code: 20703, name: "Los Algarrobos" },
        { provinceId: 2, cantonId: 7, id: 4, code: 20704, name: "Los Anastacios" },
        { provinceId: 2, cantonId: 7, id: 5, code: 20705, name: "Potrerillos" },
        { provinceId: 2, cantonId: 7, id: 6, code: 20706, name: "Potrerillos Abajo" },
        { provinceId: 2, cantonId: 7, id: 7, code: 20707, name: "Rovira" },
        { provinceId: 2, cantonId: 7, id: 8, code: 20708, name: "Tinajas" },

        { provinceId: 2, cantonId: 8, id: 1, code: 20801, name: "Gualaca" },
        { provinceId: 2, cantonId: 8, id: 2, code: 20802, name: "Hornito" },
        { provinceId: 2, cantonId: 8, id: 3, code: 20803, name: "Los Angeles" },
        { provinceId: 2, cantonId: 8, id: 4, code: 20804, name: "Paja de Sombrero" },
        { provinceId: 2, cantonId: 8, id: 5, code: 20805, name: "Rincón" },

        { provinceId: 2, cantonId: 9, id: 1, code: 20901, name: "El Nancito" },
        { provinceId: 2, cantonId: 9, id: 2, code: 20902, name: "El Porvenir" },
        { provinceId: 2, cantonId: 9, id: 3, code: 20903, name: "El Puerto" },
        { provinceId: 2, cantonId: 9, id: 4, code: 20904, name: "Remedios" },
        { provinceId: 2, cantonId: 9, id: 5, code: 20905, name: "Santa Lucía" },

        { provinceId: 2, cantonId: 10, id: 1, code: 21001, name: "Breñón" },
        { provinceId: 2, cantonId: 10, id: 2, code: 21002, name: "Cañas Gordas" },
        { provinceId: 2, cantonId: 10, id: 3, code: 21003, name: "Dominical" },
        { provinceId: 2, cantonId: 10, id: 4, code: 21004, name: "Monte Lirio" },
        { provinceId: 2, cantonId: 10, id: 5, code: 21005, name: "Plaza de Caisán" },
        { provinceId: 2, cantonId: 10, id: 6, code: 21006, name: "Río Sereno" },
        { provinceId: 2, cantonId: 10, id: 7, code: 21007,name: "Santa Cruz" },
        { provinceId: 2, cantonId: 10, id: 8, code: 21008, name: "Santa Clara" },

        { provinceId: 2, cantonId: 11, id: 1, code: 21101, name: "Las Lajas" },
        { provinceId: 2, cantonId: 11, id: 2, code: 21102, name: "Lajas Adentro" },
        { provinceId: 2, cantonId: 11, id: 3, code: 21103, name: "Juay" },
        { provinceId: 2, cantonId: 11, id: 4, code: 21104,name: "San Félix" },
        { provinceId: 2, cantonId: 11, id: 5, code: 21105, name: "Santa Cruz" },

        { provinceId: 2, cantonId: 12, id: 1, code: 21201, name: "Boca Chica" },
        { provinceId: 2, cantonId: 12, id: 2, code: 21202, name: "Boca del Monte" },
        { provinceId: 2, cantonId: 12, id: 3, code: 21203, name: "Horconcitos" },
        { provinceId: 2, cantonId: 12, id: 4, code: 21204, name: "San Juan" },
        { provinceId: 2, cantonId: 12, id: 5, code: 21205, name: "San Lorenzo" },

        { provinceId: 2, cantonId: 13, id: 1, code: 21301, name: "Volcán" },
        { provinceId: 2, cantonId: 13, id: 2, code: 21302, name: "Cerro Punta" },
        { provinceId: 2, cantonId: 13, id: 3, code: 21303, name: "Cuesta de Piedra" },
        { provinceId: 2, cantonId: 13, id: 4, code: 21304, name: "Nueva California" },
        { provinceId: 2, cantonId: 13, id: 5, code: 21305, name: "Paso Ancho" },

        { provinceId: 2, cantonId: 14, id: 1, code: 21401, name: "Bella Vista" },
        { provinceId: 2, cantonId: 14, id: 2, code: 21402, name: "Cerro Viejo" },
        { provinceId: 2, cantonId: 14, id: 3, code: 21403, name: "El Cristo" },
        { provinceId: 2, cantonId: 14, id: 4, code: 21404, name: "Justo Fidel Palacios" },
        { provinceId: 2, cantonId: 14, id: 5, code: 21405, name: "Lajas de Tolé" },
        { provinceId: 2, cantonId: 14, id: 6, code: 21406, name: "Potrero de Caña" },
        { provinceId: 2, cantonId: 14, id: 7, code: 21407, name: "Quebrada de Piedra" },
        { provinceId: 2, cantonId: 14, id: 8, code: 21408, name: "Tolé" },
        { provinceId: 2, cantonId: 14, id: 9, code: 21408, name: "Veladero" },

        { provinceId: 3, cantonId: 1, id: 1, code: 30101, name: "Aguadulce" },
        { provinceId: 3, cantonId: 1, id: 2, code: 30102, name: "Barrios Unidos" },
        { provinceId: 3, cantonId: 1, id: 3, code: 30103, name: "El Cristo" },
        { provinceId: 3, cantonId: 1, id: 4, code: 30104, name: "El Roble" },
        { provinceId: 3, cantonId: 1, id: 5, code: 30105, name: "Hato de San Juan de Dios" },
        { provinceId: 3, cantonId: 1, id: 6, code: 30106, name: "Pocrí" },
        { provinceId: 3, cantonId: 1, id: 7, code: 30107, name: "Pueblos Unidos" },
        { provinceId: 3, cantonId: 1, id: 8, code: 30108, name: "Virgen del Carmen" },

        { provinceId: 3, cantonId: 2, id: 1, code: 30201, name: "Antón" },
        { provinceId: 3, cantonId: 2, id: 2, code: 30202, name: "Caballero" },
        { provinceId: 3, cantonId: 2, id: 3, code: 30203, name: "Cabuya" },
        { provinceId: 3, cantonId: 2, id: 4, code: 30204, name: "El Chirú" },
        { provinceId: 3, cantonId: 2, id: 5, code: 30205, name: "El Retiro" },
        { provinceId: 3, cantonId: 2, id: 6, code: 30206, name: "El Valle" },
        { provinceId: 3, cantonId: 2, id: 7, code: 30207, name: "Juan Díaz" },
        { provinceId: 3, cantonId: 2, id: 8, code: 30208, name: "Río Hato" },
        { provinceId: 3, cantonId: 2, id: 9, code: 30209, name: "San Juan de Dios" },
        { provinceId: 3, cantonId: 2, id: 10, code: 302010, name: "Santa Rita" },

        { provinceId: 3, cantonId: 3, id: 1, code: 30301, name: "El Harino" },
        { provinceId: 3, cantonId: 3, id: 2, code: 30302, name: "El Potrero" },
        { provinceId: 3, cantonId: 3, id: 3, code: 30303, name: "La Pintada" },
        { provinceId: 3, cantonId: 3, id: 4, code: 30304, name: "Las Lomas" },
        { provinceId: 3, cantonId: 3, id: 5, code: 30305, name: "Llano Grande" },
        { provinceId: 3, cantonId: 3, id: 6, code: 30306, name: "Piedras Gordas" },
        { provinceId: 3, cantonId: 3, id: 7, code: 30307, name: "Llano Norte" },

        { provinceId: 3, cantonId: 4, id: 1, code: 30401, name: "Capellanía" },
        { provinceId: 3, cantonId: 4, id: 2, code: 30402, name: "El Caño" },
        { provinceId: 3, cantonId: 4, id: 3, code: 30403, name: "Guzmán" },
        { provinceId: 3, cantonId: 4, id: 4, code: 30404, name: "Las Huacas" },
        { provinceId: 3, cantonId: 4, id: 5, code: 30405, name: "Natá" },
        { provinceId: 3, cantonId: 4, id: 6, code: 30406, name: "Toza" },
        { provinceId: 3, cantonId: 4, id: 7, code: 30407, name: "Villarreal" },

        { provinceId: 3, cantonId: 5, id: 1, code: 30501, name: "El Copé" },
        { provinceId: 3, cantonId: 5, id: 2, code: 30502, name: "El Palmar" },
        { provinceId: 3, cantonId: 5, id: 3, code: 30503, name: "El Picacho" },
        { provinceId: 3, cantonId: 5, id: 4, code: 30504, name: "La Pava" },
        { provinceId: 3, cantonId: 5, id: 5, code: 30505, name: "Olá" },

        { provinceId: 3, cantonId: 6, id: 1, code: 30601, name: "Cañaveral" },
        { provinceId: 3, cantonId: 6, id: 2, code: 30602, name: "Coclé" },
        { provinceId: 3, cantonId: 6, id: 3, code: 30603, name: "Chiguirí Arriba" },
        { provinceId: 3, cantonId: 6, id: 4, code: 30604, name: "El Coco" },
        { provinceId: 3, cantonId: 6, id: 5, code: 30605, name: "Pajonal" },
        { provinceId: 3, cantonId: 6, id: 6, code: 30606, name: "Penonomé" },
        { provinceId: 3, cantonId: 6, id: 7, code: 30607, name: "Río Grande" },
        { provinceId: 3, cantonId: 6, id: 8, code: 30608, name: "Río Indio" },
        { provinceId: 3, cantonId: 6, id: 9, code: 30609, name: "Toabré" },
        { provinceId: 3, cantonId: 6, id: 10, code: 306010, name: "Tulú" },

        { provinceId: 4, cantonId: 1, id: 1, code: 40101, name: "Achiote" },
        { provinceId: 4, cantonId: 1, id: 2, code: 40102, name: "El Guabo" },
        { provinceId: 4, cantonId: 1, id: 3, code: 40103, name: "La Encantada" },
        { provinceId: 4, cantonId: 1, id: 4, code: 40104, name: "Nuevo Chagres" },
        { provinceId: 4, cantonId: 1, id: 5, code: 40105, name: "Palmas Bellas" },
        { provinceId: 4, cantonId: 1, id: 6, code: 40106, name: "Piña" },
        { provinceId: 4, cantonId: 1, id: 7, code: 40107, name: "Salud" },

        { provinceId: 4, cantonId: 2, id: 1, code: 40201, name: "Barrio Norte" },
        { provinceId: 4, cantonId: 2, id: 2, code: 40202, name: "Barrio Sur" },
        { provinceId: 4, cantonId: 2, id: 3, code: 40203, name: "Buena Vista" },
        { provinceId: 4, cantonId: 2, id: 4, code: 40204, name: "Cativá" },
        { provinceId: 4, cantonId: 2, id: 5, code: 40205, name: "Ciricito" },
        { provinceId: 4, cantonId: 2, id: 6, code: 40206, name: "Cristóbal" },
        { provinceId: 4, cantonId: 2, id: 7, code: 40207, name: "Cristóbal Este" },
        { provinceId: 4, cantonId: 2, id: 8, code: 40208, name: "Escobal" },
        { provinceId: 4, cantonId: 2, id: 9, code: 40209, name: "Limón" },
        { provinceId: 4, cantonId: 2, id: 10, code: 402010, name: "Nueva Providencia" },
        { provinceId: 4, cantonId: 2, id: 11, code: 402011,name: "Puerto Pilón" },
        { provinceId: 4, cantonId: 2, id: 12, code: 402012 ,name: "Sabanitas" },
        { provinceId: 4, cantonId: 2, id: 13, code: 402013, name: "Salamanca" },
        { provinceId: 4, cantonId: 2, id: 14, code: 402014, name: "San Juan" },
        { provinceId: 4, cantonId: 2, id: 15, code: 402015, name: "Santa Rosa" },

        { provinceId: 4, cantonId: 3, id: 1, code: 40301, name: "Coclé del Norte" },
        { provinceId: 4, cantonId: 3, id: 2, code: 40302, name: "El Guásimo" },
        { provinceId: 4, cantonId: 3, id: 3, code: 40303, name: "Gobea" },
        { provinceId: 4, cantonId: 3, id: 4, code: 40304, name: "Miguel de la Borda" },
        { provinceId: 4, cantonId: 3, id: 5, code: 40305, name: "Río Indio" },

        { provinceId: 4, cantonId: 4, id: 1, code: 40401, name: "Cacique" },
        { provinceId: 4, cantonId: 4, id: 2, code: 40402, name: "Garrote" },
        { provinceId: 4, cantonId: 4, id: 3, code: 40403, name: "Isla Grande" },
        { provinceId: 4, cantonId: 4, id: 4, code: 40404, name: "María Chiquita" },
        { provinceId: 4, cantonId: 4, id: 5, code: 40405, name: "Portobelo" },

        { provinceId: 4, cantonId: 5, id: 1, code: 40501, name: "Cuango" },
        { provinceId: 4, cantonId: 5, id: 2, code: 40502, name: "Miramar" },
        { provinceId: 4, cantonId: 5, id: 3, code: 40503, name: "Nombre de Dios" },
        { provinceId: 4, cantonId: 5, id: 4, code: 40504, name: "Palenque" },
        { provinceId: 4, cantonId: 5, id: 5, code: 40505, name: "Palmira" },
        { provinceId: 4, cantonId: 5, id: 6, code: 40506, name: "Playa Chiquita" },
        { provinceId: 4, cantonId: 5, id: 7, code: 40507, name: "Santa Isabel" },
        { provinceId: 4, cantonId: 5, id: 8, code: 40508, name: "Viento Frío" },

        { provinceId: 4, cantonId: 6, id: 1, code: 40601, name: "San José del General" },
        { provinceId: 4, cantonId: 6, id: 2, code: 40602, name: "San Juan de Turbe" },
        { provinceId: 4, cantonId: 6, id: 3, code: 40603, name: "Nueva Esperanza" },

        { provinceId: 5, cantonId: 1, id: 1, code: 50101, name: "Camogantí" },
        { provinceId: 5, cantonId: 1, id: 2, code: 50102, name: "Chepigana" },
        { provinceId: 5, cantonId: 1, id: 3, code: 50103, name: "Garachiné" },
        { provinceId: 5, cantonId: 1, id: 4, code: 50104, name: "Jaqué" },
        { provinceId: 5, cantonId: 1, id: 5, code: 50105, name: "La Palma" },
        { provinceId: 5, cantonId: 1, id: 6, code: 50106, name: "Puerto Piña" },
        { provinceId: 5, cantonId: 1, id: 7, code: 50107, name: "Sambú" },
        { provinceId: 5, cantonId: 1, id: 8, code: 50108, name: "Setegantí" },
        { provinceId: 5, cantonId: 1, id: 9, code: 50109, name: "Taimatí" },
        { provinceId: 5, cantonId: 1, id: 10, code: 501010, name: "Tucutí" },

        { provinceId: 5, cantonId: 2, id: 1, code: 50201, name: "Boca de Cupe" },
        { provinceId: 5, cantonId: 2, id: 2, code: 50202, name: "El Real de Santa María" },
        { provinceId: 5, cantonId: 2, id: 3, code: 50203, name: "Metetí" },
        { provinceId: 5, cantonId: 2, id: 4, code: 50204, name: "Paya" },
        { provinceId: 5, cantonId: 2, id: 5, code: 50205, name: "Pinogana" },
        { provinceId: 5, cantonId: 2, id: 6, code: 50206, name: "Púcuro" },
        { provinceId: 5, cantonId: 2, id: 7, code: 50207, name: "Yape" },
        { provinceId: 5, cantonId: 2, id: 8, code: 50208, name: "Yaviza" },
        { provinceId: 5, cantonId: 2, id: 9, code: 50209, name: "Wargandí" },

        { provinceId: 5, cantonId: 3, id: 1, code: 50301, name: "Agua Fría" },
        { provinceId: 5, cantonId: 3, id: 2, code: 50302, name: "Cucunatí" },
        { provinceId: 5, cantonId: 3, id: 3, code: 50303, name: "Río Congo" },
        { provinceId: 5, cantonId: 3, id: 4, code: 50304, name: "Río Congo Arriba" },
        { provinceId: 5, cantonId: 3, id: 5, code: 50305, name: "Río Iglesias" },
        { provinceId: 5, cantonId: 3, id: 6, code: 50306, name: "Santa Fe" },
        { provinceId: 5, cantonId: 3, id: 7, code: 50307, name: "Zapallal" },

        { provinceId: 5, cantonId: 4, id: 1, code: 50401, name: "Guna de Wargandí" },

        { provinceId: 6, cantonId: 1, id: 1, code: 60101, name: "Chitré" },
        { provinceId: 6, cantonId: 1, id: 2, code: 60102, name: "La Arena" },
        { provinceId: 6, cantonId: 1, id: 3, code: 60103, name: "Llano Bonito" },
        { provinceId: 6, cantonId: 1, id: 4, code: 60104, name: "San Juan Bautista" },
        { provinceId: 6, cantonId: 1, id: 5, code: 60105, name: "Monagrillo" },

        { provinceId: 6, cantonId: 2, id: 1, code: 60201, name: "Chepo" },
        { provinceId: 6, cantonId: 2, id: 2, code: 60202, name: "Chumical" },
        { provinceId: 6, cantonId: 2, id: 3, code: 60203, name: "El Toro" },
        { provinceId: 6, cantonId: 2, id: 4, code: 60204, name: "Las Minas" },
        { provinceId: 6, cantonId: 2, id: 5, code: 60205, name: "Leones" },
        { provinceId: 6, cantonId: 2, id: 6, code: 60206, name: "Quebrada del Rosario" },
        { provinceId: 6, cantonId: 2, id: 7, code: 60207, name: "Quebrada El Ciprián" },

        { provinceId: 6, cantonId: 3, id: 1, code: 60301, name: "El Capurí" },
        { provinceId: 6, cantonId: 3, id: 2, code: 60302, name: "El Calabacito" },
        { provinceId: 6, cantonId: 3, id: 3, code: 60303, name: "El Cedro" },
        { provinceId: 6, cantonId: 3, id: 4, code: 60304, name: "La Arena" },
        { provinceId: 6, cantonId: 3, id: 5, code: 60305, name: "La Pitaloza" },
        { provinceId: 6, cantonId: 3, id: 6, code: 60306, name: "Las Llanas" },
        { provinceId: 6, cantonId: 3, id: 7, code: 60307, name: "Los Cerritos" },
        { provinceId: 6, cantonId: 3, id: 8, code: 60308, name: "Los Cerros de Paja" },
        { provinceId: 6, cantonId: 3, id: 9, code: 60309, name: "Los Pozos" },

        { provinceId: 6, cantonId: 4, id: 1, code: 60401, name: "Cerro Largo" },
        { provinceId: 6, cantonId: 4, id: 2, code: 60402, name: "El Tijera" },
        { provinceId: 6, cantonId: 4, id: 3, code: 60403, name: "Entradero del Castillo" },
        { provinceId: 6, cantonId: 4, id: 4, code: 60404, name: "Los Llanos" },
        { provinceId: 6, cantonId: 4, id: 5, code: 60405, name: "Llano Grande" },
        { provinceId: 6, cantonId: 4, id: 6, code: 60406, name: "Menchaca" },
        { provinceId: 6, cantonId: 4, id: 7, code: 60407, name: "Peñas Chatas" },
        { provinceId: 6, cantonId: 4, id: 8, code: 60408, name: "Ocú" },

        { provinceId: 6, cantonId: 5, id: 1, code: 60501, name: "Cabuya" },
        { provinceId: 6, cantonId: 5, id: 2, code: 60502, name: "Los Castillos" },
        { provinceId: 6, cantonId: 5, id: 3, code: 60503, name: "Llano de la Cruz" },
        { provinceId: 6, cantonId: 5, id: 4, code: 60504, name: "París" },
        { provinceId: 6, cantonId: 5, id: 5, code: 60505, name: "Parita" },
        { provinceId: 6, cantonId: 5, id: 6, code: 60506, name: "Portobelillo" },
        { provinceId: 6, cantonId: 5, id: 7, code: 60507, name: "Potuga" },

        { provinceId: 6, cantonId: 6, id: 1, code: 60601, name: "El Barrero" },
        { provinceId: 6, cantonId: 6, id: 2, code: 60602, name: "El Pedregoso" },
        { provinceId: 6, cantonId: 6, id: 3, code: 60603, name: "El Ciruelo" },
        { provinceId: 6, cantonId: 6, id: 4, code: 60604, name: "El Pájaro" },
        { provinceId: 6, cantonId: 6, id: 5, code: 60605, name: "Las Cabras" },
        { provinceId: 6, cantonId: 6, id: 6, code: 60606, name: "Pesé" },
        { provinceId: 6, cantonId: 6, id: 7, code: 60607, name: "Rincón Hondo" },
        { provinceId: 6, cantonId: 6, id: 8, code: 60608, name: "Sabanagrande" },

        { provinceId: 6, cantonId: 7, id: 1, code: 60701, name: "Chupampa" },
        { provinceId: 6, cantonId: 7, id: 2, code: 60702, name: "El Rincón" },
        { provinceId: 6, cantonId: 7, id: 3, code: 60703, name: "El Limón" },
        { provinceId: 6, cantonId: 7, id: 4, code: 60704, name: "Los Canelos" },
        { provinceId: 6, cantonId: 7, id: 5, code: 60705, name: "Santa María" },

        { provinceId: 7, cantonId: 1, id: 1, code: 70101, name: "El Espinal" },
        { provinceId: 7, cantonId: 1, id: 2, code: 70102, name: "El Hato" },
        { provinceId: 7, cantonId: 1, id: 3, code: 70103, name: "El Macano" },
        { provinceId: 7, cantonId: 1, id: 4, code: 70104, name: "Guararé" },
        { provinceId: 7, cantonId: 1, id: 5, code: 70105, name: "Guararé Arriba" },
        { provinceId: 7, cantonId: 1, id: 6, code: 70106, name: "La Enea" },
        { provinceId: 7, cantonId: 1, id: 7, code: 70107, name: "La Pasera" },
        { provinceId: 7, cantonId: 1, id: 8, code: 70108, name: "Las Trancas" },
        { provinceId: 7, cantonId: 1, id: 9, code: 70109, name: "Llano Abajo" },
        { provinceId: 7, cantonId: 1, id: 10, code: 701010, name: "Perales" },

        { provinceId: 7, cantonId: 2, id: 1, code: 70201, name: "Bajo Corral" },
        { provinceId: 7, cantonId: 2, id: 2, code: 70202, name: "Bayano" },
        { provinceId: 7, cantonId: 2, id: 3, code: 70203, name: "El Carate" },
        { provinceId: 7, cantonId: 2, id: 4, code: 70204, name: "El Cocal" },
        { provinceId: 7, cantonId: 2, id: 5, code: 70205, name: "El Manantial" },
        { provinceId: 7, cantonId: 2, id: 6, code: 70206, name: "El Muñoz" },
        { provinceId: 7, cantonId: 2, id: 7, code: 70207, name: "El Pedregoso" },
        { provinceId: 7, cantonId: 2, id: 8, code: 70208, name: "El Sesteadero" },
        { provinceId: 7, cantonId: 2, id: 9, code: 70209, name: "La Laja" },
        { provinceId: 7, cantonId: 2, id: 10, code: 702010, name: "La Miel" },
        { provinceId: 7, cantonId: 2, id: 11, code: 702011, name: "La Palma" },
        { provinceId: 7, cantonId: 2, id: 12, code: 702012, name: "La Tiza" },
        { provinceId: 7, cantonId: 2, id: 13, code: 702013, name: "Las Palmitas" },
        { provinceId: 7, cantonId: 2, id: 14, code: 702014, name: "Las Tablas Abajo" },
        { provinceId: 7, cantonId: 2, id: 15, code: 702015, name: "Nuario" },
        { provinceId: 7, cantonId: 2, id: 16, code: 702016, name: "Palmira" },
        { provinceId: 7, cantonId: 2, id: 17, code: 702017, name: "Peña Blanca" },
        { provinceId: 7, cantonId: 2, id: 18, code: 702018, name: "Río Hondo" },
        { provinceId: 7, cantonId: 2, id: 19, code: 702019, name: "San José" },
        { provinceId: 7, cantonId: 2, id: 20, code: 702020, name: "San Miguel" },
        { provinceId: 7, cantonId: 2, id: 21, code: 702021, name: "Las Tablas" },
        { provinceId: 7, cantonId: 2, id: 22, code: 702022, name: "Santo Domingo" },
        { provinceId: 7, cantonId: 2, id: 23, code: 702023,  name: "Valle Rico" },
        { provinceId: 7, cantonId: 2, id: 24, code: 702024,  name: "Vallerriquito" },

        { provinceId: 7, cantonId: 3, id: 1, code: 70301, name: "El Ejido" },
        { provinceId: 7, cantonId: 3, id: 2, code: 70302, name: "El Guásimo" },
        { provinceId: 7, cantonId: 3, id: 3, code: 70303, name: "La Colorada" },
        { provinceId: 7, cantonId: 3, id: 4, code: 70304, name: "La Espigadilla" },
        { provinceId: 7, cantonId: 3, id: 5, code: 70305, name: "La Villa de Los Santos" },
        { provinceId: 7, cantonId: 3, id: 6, code: 70306, name: "Las Cruces" },
        { provinceId: 7, cantonId: 3, id: 7, code: 70307, name: "Las Guabas" },
        { provinceId: 7, cantonId: 3, id: 8, code: 70308, name: "Los Ángeles" },
        { provinceId: 7, cantonId: 3, id: 9, code: 70309, name: "Los Olivos" },
        { provinceId: 7, cantonId: 3, id: 10, code: 703011, name: "Llano Largo" },
        { provinceId: 7, cantonId: 3, id: 11, code: 703012, name: "Sabanagrande" },
        { provinceId: 7, cantonId: 3, id: 12, code: 703013, name: "Santa Ana" },
        { provinceId: 7, cantonId: 3, id: 13, code: 703014, name: "Tres Quebradas" },
        { provinceId: 7, cantonId: 3, id: 14, code: 703015, name: "Villa Lourdes" },
        { provinceId: 7, cantonId: 3, id: 15, code: 703016, name: "Agua Buena" },

        { provinceId: 7, cantonId: 4, id: 1, code: 70401, name: "Bahía Honda" },
        { provinceId: 7, cantonId: 4, id: 2, code: 70402, name: "Bajos de Güera" },
        { provinceId: 7, cantonId: 4, id: 3, code: 70403, name: "Corozal" },
        { provinceId: 7, cantonId: 4, id: 4, code: 70404, name: "Chupá" },
        { provinceId: 7, cantonId: 4, id: 5, code: 70405, name: "El Cedro" },
        { provinceId: 7, cantonId: 4, id: 6, code: 70406, name: "Espino Amarillo" },
        { provinceId: 7, cantonId: 4, id: 7, code: 70407, name: "La Mesa" },
        { provinceId: 7, cantonId: 4, id: 8, code: 70408, name: "Las Palmas" },
        { provinceId: 7, cantonId: 4, id: 9, code: 70409, name: "Llano de Piedras" },
        { provinceId: 7, cantonId: 4, id: 10, code: 704011, name: "Macaracas" },
        { provinceId: 7, cantonId: 4, id: 11, code: 704012, name: "Mogollón" },

        { provinceId: 7, cantonId: 5, id: 1, code: 70501, name: "Los Asientos" },
        { provinceId: 7, cantonId: 5, id: 2, code: 70502, name: "Mariabé" },
        { provinceId: 7, cantonId: 5, id: 3, code: 70503, name: "Oria Arriba" },
        { provinceId: 7, cantonId: 5, id: 4, code: 70504, name: "Pedasí" },
        { provinceId: 7, cantonId: 5, id: 5, code: 70505, name: "Purio" },

        { provinceId: 7, cantonId: 6, id: 1, code: 70601, name: "El Cañafístulo" },
        { provinceId: 7, cantonId: 6, id: 2, code: 70602, name: "Lajamina" },
        { provinceId: 7, cantonId: 6, id: 3, code: 70603, name: "Paraíso" },
        { provinceId: 7, cantonId: 6, id: 4, code: 70604, name: "Paritilla" },
        { provinceId: 7, cantonId: 6, id: 5, code: 70605, name: "Pocrí" },

        { provinceId: 7, cantonId: 7, id: 1, code: 70701, name: "Altos de Güera" },
        { provinceId: 7, cantonId: 7, id: 2, code: 70702, name: "Cambutal" },
        { provinceId: 7, cantonId: 7, id: 3, code: 70703, name: "Cañas" },
        { provinceId: 7, cantonId: 7, id: 4, code: 70704, name: "El Bebedero" },
        { provinceId: 7, cantonId: 7, id: 5, code: 70705, name: "El Cacao" },
        { provinceId: 7, cantonId: 7, id: 6, code: 70706, name: "El Cortezo" },
        { provinceId: 7, cantonId: 7, id: 7, code: 70707, name: "Flores" },
        { provinceId: 7, cantonId: 7, id: 8, code: 70708, name: "Guánico" },
        { provinceId: 7, cantonId: 7, id: 9, code: 70709, name: "Isla de Cañas" },
        { provinceId: 7, cantonId: 7, id: 10, code: 707010, name: "La Tronosa" },
        { provinceId: 7, cantonId: 7, id: 11, code: 707011, name: "Tonosí" },

        { provinceId: 8, cantonId: 1, id: 1, code: 80101, name: "La Ensenada" },
        { provinceId: 8, cantonId: 1, id: 2, code: 80102, name: "La Esmeralda" },
        { provinceId: 8, cantonId: 1, id: 3, code: 80103, name: "La Guinea" },
        { provinceId: 8, cantonId: 1, id: 4, code: 80104, name: "Pedro González" },
        { provinceId: 8, cantonId: 1, id: 5, code: 80105, name: "Saboga" },
        { provinceId: 8, cantonId: 1, id: 6, code: 80106, name: "San Miguel" },

        { provinceId: 8, cantonId: 2, id: 1, code: 80201, name: "Cañita" },
        { provinceId: 8, cantonId: 2, id: 2, code: 80202, name: "Chepillo" },
        { provinceId: 8, cantonId: 2, id: 3, code: 80203, name: "El Llano" },
        { provinceId: 8, cantonId: 2, id: 4, code: 80204, name: "Las Margaritas" },
        { provinceId: 8, cantonId: 2, id: 5, code: 80205, name: "Madugandí" },
        { provinceId: 8, cantonId: 2, id: 6, code: 80206, name: "Chepo" },
        { provinceId: 8, cantonId: 2, id: 7, code: 80207, name: "Santa Cruz de Chinina" },
        { provinceId: 8, cantonId: 2, id: 8, code: 80208, name: "Tortí" },

        { provinceId: 8, cantonId: 3, id: 1, code: 80301, name: "Brujas" },
        { provinceId: 8, cantonId: 3, id: 2, code: 80302, name: "Chimán" },
        { provinceId: 8, cantonId: 3, id: 3, code: 80303, name: "Gonzalo Vásquez" },
        { provinceId: 8, cantonId: 3, id: 4, code: 80304, name: "Pásiga" },
        { provinceId: 8, cantonId: 3, id: 5, code: 80305, name: "Unión Santeña" },

        { provinceId: 8, cantonId: 4, id: 1, code: 80401, name: "Guna de Madugandí" },

        { provinceId: 8, cantonId: 5, id: 1, code: 80501, name: "24 de Diciembre" },
        { provinceId: 8, cantonId: 5, id: 2, code: 80502, name: "Alcalde Díaz" },
        { provinceId: 8, cantonId: 5, id: 3, code: 80503, name: "Ancón" },
        { provinceId: 8, cantonId: 5, id: 4, code: 80504, name: "Betania" },
        { provinceId: 8, cantonId: 5, id: 5, code: 80505, name: "Bella Vista" },
        { provinceId: 8, cantonId: 5, id: 6, code: 80506, name: "Calidonia" },
        { provinceId: 8, cantonId: 5, id: 7, code: 80507, name: "Caimitillo" },
        { provinceId: 8, cantonId: 5, id: 8, code: 80508, name: "Chilibre" },
        { provinceId: 8, cantonId: 5, id: 9, code: 80509, name: "Curundú" },
        { provinceId: 8, cantonId: 5, id: 10, code: 805010, name: "Don Bosco" },
        { provinceId: 8, cantonId: 5, id: 11, code: 805011, name: "El Chorrillo" },
        { provinceId: 8, cantonId: 5, id: 12, code: 805012, name: "Ernesto Córdoba Campos" },
        { provinceId: 8, cantonId: 5, id: 13, code: 805013, name: "Juan Díaz" },
        { provinceId: 8, cantonId: 5, id: 14, code: 805014, name: "Las Cumbres" },
        { provinceId: 8, cantonId: 5, id: 15, code: 805015, name: "Las Garzas" },
        { provinceId: 8, cantonId: 5, id: 16, code: 805016, name: "Las Mañanitas" },
        { provinceId: 8, cantonId: 5, id: 17, code: 805017, name: "Pacora" },
        { provinceId: 8, cantonId: 5, id: 18, code: 805018, name: "Parque Lefevre" },
        { provinceId: 8, cantonId: 5, id: 19, code: 805019, name: "Pedregal" },
        { provinceId: 8, cantonId: 5, id: 20, code: 805020, name: "Pueblo Nuevo" },
        { provinceId: 8, cantonId: 5, id: 21, code: 805021, name: "Río Abajo" },
        { provinceId: 8, cantonId: 5, id: 22, code: 805022, name: "San Felipe" },
        { provinceId: 8, cantonId: 5, id: 23, code: 805023, name: "San Francisco" },
        { provinceId: 8, cantonId: 5, id: 24, code: 805024, name: "San Martín" },
        { provinceId: 8, cantonId: 5, id: 25, code: 805025, name: "Santa Ana" },
        { provinceId: 8, cantonId: 5, id: 26, code: 805026, name: "Tocumen" }, 

        { provinceId: 8, cantonId: 6, id: 1, code: 80601, name: "Amelia Denis de Icaza" },
        { provinceId: 8, cantonId: 6, id: 2, code: 80602, name: "Arnulfo Arias" },
        { provinceId: 8, cantonId: 6, id: 3, code: 80603, name: "Belisario Frías" },
        { provinceId: 8, cantonId: 6, id: 4, code: 80604, name: "Belisario Porras" },
        { provinceId: 8, cantonId: 6, id: 5, code: 80605, name: "José Domingo Espinar" },
        { provinceId: 8, cantonId: 6, id: 6, code: 80606, name: "Mateo Iturralde" },
        { provinceId: 8, cantonId: 6, id: 7, code: 80607, name: "Omar Torrijos" },
        { provinceId: 8, cantonId: 6, id: 8, code: 80608, name: "Rufina Alfaro" },
        { provinceId: 8, cantonId: 6, id: 9, code: 80609, name: "Victoriano Lorenzo" },

        { provinceId: 8, cantonId: 7, id: 1, code: 80701, name: "Otoque Occidente" },
        { provinceId: 8, cantonId: 7, id: 2, code: 80702, name: "Otoque Oriente" },
        { provinceId: 8, cantonId: 7, id: 3, code: 80703, name: "Taboga" },

        { provinceId: 9, cantonId: 1, id: 1, code: 90101, name: "Arraiján" },
        { provinceId: 9, cantonId: 1, id: 2, code: 90102, name: "Burunga" },
        { provinceId: 9, cantonId: 1, id: 3, code: 90103, name: "Cerro Silvestre" },
        { provinceId: 9, cantonId: 1, id: 4, code: 90104, name: "Juan Demóstenes Arosemena" },
        { provinceId: 9, cantonId: 1, id: 5, code: 90105, name: "Nuevo Emperador" },
        { provinceId: 9, cantonId: 1, id: 6, code: 90106, name: "Santa Clara" },
        { provinceId: 9, cantonId: 1, id: 7, code: 90107, name: "Veracruz" },
        { provinceId: 9, cantonId: 1, id: 8, code: 90108, name: "Vista Alegre" },

        { provinceId: 9, cantonId: 2, id: 1, code: 90201, name: "Caimito" },
        { provinceId: 9, cantonId: 2, id: 2, code: 90202, name: "Campana" },
        { provinceId: 9, cantonId: 2, id: 3, code: 90203, name: "Capira" },
        { provinceId: 9, cantonId: 2, id: 4, code: 90204, name: "Cermeño" },
        { provinceId: 9, cantonId: 2, id: 5, code: 90205, name: "Cirí de Los Sotos" },
        { provinceId: 9, cantonId: 2, id: 6, code: 90206, name: "Cirí Grande" },
        { provinceId: 9, cantonId: 2, id: 7, code: 90207, name: "El Cacao" },
        { provinceId: 9, cantonId: 2, id: 8, code: 90208, name: "La Trinidad" },
        { provinceId: 9, cantonId: 2, id: 9, code: 90209, name: "Las Ollas Arriba" },
        { provinceId: 9, cantonId: 2, id: 10, code: 902010, name: "Lídice" },
        { provinceId: 9, cantonId: 2, id: 11, code: 902011, name: "Villa Carmen" },
        { provinceId: 9, cantonId: 2, id: 12, code: 902012, name: "Villa Rosario" },
        { provinceId: 9, cantonId: 2, id: 13, code: 902013, name: "Santa Rosa" },

        { provinceId: 9, cantonId: 3, id: 1, code: 90301, name: "Bejuco" },
        { provinceId: 9, cantonId: 3, id: 2, code: 90302, name: "Buenos Aires" },
        { provinceId: 9, cantonId: 3, id: 3, code: 90303, name: "Cabuya" },
        { provinceId: 9, cantonId: 3, id: 4, code: 90304, name: "Chame" },
        { provinceId: 9, cantonId: 3, id: 5, code: 90305, name: "Chicá" },
        { provinceId: 9, cantonId: 3, id: 6, code: 90306, name: "El Líbano" },
        { provinceId: 9, cantonId: 3, id: 7, code: 90307, name: "Las Lajas" },
        { provinceId: 9, cantonId: 3, id: 8, code: 90308, name: "Nueva Gorgona" },
        { provinceId: 9, cantonId: 3, id: 9, code: 90309, name: "Punta Chame" },
        { provinceId: 9, cantonId: 3, id: 10, code: 903010, name: "Sajalices" },
        { provinceId: 9, cantonId: 3, id: 11, code: 903011, name: "Sorá" },

        { provinceId: 9, cantonId: 4, id: 1, code: 90401, name: "Amador" },
        { provinceId: 9, cantonId: 4, id: 2, code: 90402, name: "Arosemena" },
        { provinceId: 9, cantonId: 4, id: 3, code: 90403, name: "Barrio Balboa" },
        { provinceId: 9, cantonId: 4, id: 4, code: 90404, name: "Barrio Colón" },
        { provinceId: 9, cantonId: 4, id: 5, code: 90405, name: "El Arado" },
        { provinceId: 9, cantonId: 4, id: 6, code: 90406, name: "El Coco" },
        { provinceId: 9, cantonId: 4, id: 7, code: 90407, name: "Feuillet" },
        { provinceId: 9, cantonId: 4, id: 8, code: 90408, name: "Guadalupe" },
        { provinceId: 9, cantonId: 4, id: 9, code: 90409, name: "Herrera" },
        { provinceId: 9, cantonId: 4, id: 10, code: 904010, name: "Hurtado" },
        { provinceId: 9, cantonId: 4, id: 11, code: 904011, name: "Iturralde" },
        { provinceId: 9, cantonId: 4, id: 12, code: 904012, name: "La Represa" },
        { provinceId: 9, cantonId: 4, id: 13, code: 904013, name: "Los Díaz" },
        { provinceId: 9, cantonId: 4, id: 14, code: 904014, name: "Mendoza" },
        { provinceId: 9, cantonId: 4, id: 15, code: 904015, name: "Obaldía" },
        { provinceId: 9, cantonId: 4, id: 16, code: 904016, name: "Playa Leona" },
        { provinceId: 9, cantonId: 4, id: 17, code: 904017, name: "Puerto Caimito" },
        { provinceId: 9, cantonId: 4, id: 18, code: 904018, name: "Santa Rita" },

        { provinceId: 9, cantonId: 5, id: 1, code: 90501, name: "El Espino" },
        { provinceId: 9, cantonId: 5, id: 2, code: 90502, name: "El Higo" },
        { provinceId: 9, cantonId: 5, id: 3, code: 90503, name: "Guayabito" },
        { provinceId: 9, cantonId: 5, id: 4, code: 90504, name: "La Ermita" },
        { provinceId: 9, cantonId: 5, id: 5, code: 90505, name: "La Laguna" },
        { provinceId: 9, cantonId: 5, id: 6, code: 90506, name: "Las Uvas" },
        { provinceId: 9, cantonId: 5, id: 7, code: 90507, name: "Los Llanitos" },
        { provinceId: 9, cantonId: 5, id: 8, code: 90508, name: "San Carlos" },
        { provinceId: 9, cantonId: 5, id: 9, code: 90509, name: "San José" },

        { provinceId: 10, cantonId: 1, id: 1, code: 100101, name: "Atalaya" },
        { provinceId: 10, cantonId: 1, id: 2, code: 100102, name: "El Barrito" },
        { provinceId: 10, cantonId: 1, id: 3, code: 100103, name: "La Carrillo" },
        { provinceId: 10, cantonId: 1, id: 4, code: 100104, name: "La Montañuela" },
        { provinceId: 10, cantonId: 1, id: 5, code: 100105, name: "San Antonio" },

        { provinceId: 10, cantonId: 2, id: 1, code: 100201, name: "Barnizal" },
        { provinceId: 10, cantonId: 2, id: 2, code: 100202, name: "Calobre" },
        { provinceId: 10, cantonId: 2, id: 3, code: 100203, name: "Chitra" },
        { provinceId: 10, cantonId: 2, id: 4, code: 100204, name: "El Cocla" },
        { provinceId: 10, cantonId: 2, id: 5, code: 100205, name: "El Potrero" },
        { provinceId: 10, cantonId: 2, id: 6, code: 100206, name: "La Laguna" },
        { provinceId: 10, cantonId: 2, id: 7, code: 100207, name: "La Raya de Calobre" },
        { provinceId: 10, cantonId: 2, id: 8, code: 100208, name: "La Tetilla" },
        { provinceId: 10, cantonId: 2, id: 9, code: 100209, name: "La Yeguada" },
        { provinceId: 10, cantonId: 2, id: 10, code: 1002010, name: "Las Guías" },
        { provinceId: 10, cantonId: 2, id: 11, code: 1002011, name: "Monjarás" },
        { provinceId: 10, cantonId: 2, id: 12, code: 1002012, name: "San José" },

        { provinceId: 10, cantonId: 3, id: 1, code: 100301, name: "Cañazas" },
        { provinceId: 10, cantonId: 3, id: 2, code: 100302, name: "Cerro de Plata" },
        { provinceId: 10, cantonId: 3, id: 3, code: 100303, name: "El Aromillo" },
        { provinceId: 10, cantonId: 3, id: 4, code: 100304, name: "El Picador" },
        { provinceId: 10, cantonId: 3, id: 5, code: 100305, name: "Las Cruces" },
        { provinceId: 10, cantonId: 3, id: 6, code: 100306, name: "Los Valles" },
        { provinceId: 10, cantonId: 3, id: 7, code: 100307, name: "San José" },
        { provinceId: 10, cantonId: 3, id: 8, code: 100308, name: "San Marcelo" },

        { provinceId: 10, cantonId: 4, id: 1, code: 100401, name: "Bisvalles" },
        { provinceId: 10, cantonId: 4, id: 2, code: 100402, name: "Boró" },
        { provinceId: 10, cantonId: 4, id: 3, code: 100403, name: "El Higo" },
        { provinceId: 10, cantonId: 4, id: 4, code: 100404, name: "La Mesa" },
        { provinceId: 10, cantonId: 4, id: 5, code: 100405, name: "Los Milagros" },
        { provinceId: 10, cantonId: 4, id: 6, code: 100406, name: "Llano Grande" },
        { provinceId: 10, cantonId: 4, id: 7, code: 100407, name: "San Bartolo" },

        { provinceId: 10, cantonId: 5, id: 1, code: 100501, name: "Cerro de Casa" },
        { provinceId: 10, cantonId: 5, id: 2, code: 100502, name: "Corozal" },
        { provinceId: 10, cantonId: 5, id: 3, code: 100503, name: "El María" },
        { provinceId: 10, cantonId: 5, id: 4, code: 100504, name: "El Prado" },
        { provinceId: 10, cantonId: 5, id: 5, code: 100505, name: "El Rincón" },
        { provinceId: 10, cantonId: 5, id: 6, code: 100506, name: "Las Palmas" },
        { provinceId: 10, cantonId: 5, id: 7, code: 100507, name: "Lolá" },
        { provinceId: 10, cantonId: 5, id: 8, code: 100508, name: "Manuel E. Amador Terrero" },
        { provinceId: 10, cantonId: 5, id: 9, code: 100509, name: "Pixvae" },
        { provinceId: 10, cantonId: 5, id: 10, code: 1005010, name: "Puerto Vidal" },
        { provinceId: 10, cantonId: 5, id: 11, code: 1005011, name: "San Martín de Porres" },
        { provinceId: 10, cantonId: 5, id: 12, code: 1005012, name: "Viguí" },
        { provinceId: 10, cantonId: 5, id: 13, code: 1005013, name: "Zapotillo" },

        { provinceId: 10, cantonId: 6, id: 1, code: 100601, name: "Arenas" },
        { provinceId: 10, cantonId: 6, id: 2, code: 100602, name: "El Cacao" },
        { provinceId: 10, cantonId: 6, id: 3, code: 100603, name: "Mariato" },
        { provinceId: 10, cantonId: 6, id: 4, code: 100604, name: "Quebro" },
        { provinceId: 10, cantonId: 6, id: 5, code: 100605, name: "Tebario" },

        { provinceId: 10, cantonId: 7, id: 1, code: 100701, name: "Cébaco" },
        { provinceId: 10, cantonId: 7, id: 2, code: 100702, name: "Costa Hermosa" },
        { provinceId: 10, cantonId: 7, id: 3, code: 100703, name: "Gobernadora" },
        { provinceId: 10, cantonId: 7, id: 4, code: 100704, name: "La Garceana" },
        { provinceId: 10, cantonId: 7, id: 5, code: 100705, name: "Leones" },
        { provinceId: 10, cantonId: 7, id: 6, code: 100706, name: "Montijo" },
        { provinceId: 10, cantonId: 7, id: 7, code: 100707, name: "Pilón" },
        { provinceId: 10, cantonId: 7, id: 8, code: 100708, name: "Unión del Norte" },

        { provinceId: 10, cantonId: 8, id: 1, code: 100801, name: "Catorce de Noviembre" },
        { provinceId: 10, cantonId: 8, id: 2, code: 100802, name: "Río de Jesús" },
        { provinceId: 10, cantonId: 8, id: 3, code: 100803, name: "Las Huacas" },
        { provinceId: 10, cantonId: 8, id: 4, code: 100804, name: "Los Castillos" },
        { provinceId: 10, cantonId: 8, id: 5, code: 100805, name: "Utira" },

        { provinceId: 10, cantonId: 9, id: 1, code: 100901, name: "Corral Falso" },
        { provinceId: 10, cantonId: 9, id: 2, code: 100902, name: "Los Hatillos" },
        { provinceId: 10, cantonId: 9, id: 3, code: 100903, name: "Remance" },
        { provinceId: 10, cantonId: 9, id: 4, code: 100904, name: "San Francisco" },
        { provinceId: 10, cantonId: 9, id: 5, code: 100905, name: "San Juan" },
        { provinceId: 10, cantonId: 9, id: 6, code: 100906, name: "San José" },

        { provinceId: 10, cantonId: 10, id: 1, code: 101001, name: "Calovébora" },
        { provinceId: 10, cantonId: 10, id: 2, code: 101002, name: "El Alto" },
        { provinceId: 10, cantonId: 10, id: 3, code: 101003, name: "El Cuay" },
        { provinceId: 10, cantonId: 10, id: 4, code: 101004, name: "El Pantano" },
        { provinceId: 10, cantonId: 10, id: 5, code: 101005, name: "Gatuncito" },
        { provinceId: 10, cantonId: 10, id: 6, code: 101006, name: "Río Luis" },
        { provinceId: 10, cantonId: 10, id: 7, code: 101007, name: "Rubén Cantú" },
        { provinceId: 10, cantonId: 10, id: 8, code: 101008, name: "Santa Fe" },

        { provinceId: 10, cantonId: 11, id: 1, code: 101101, name: "Canto del Llano" },
        { provinceId: 10, cantonId: 11, id: 2, code: 101102, name: "Carlos Santana Ávila" },
        { provinceId: 10, cantonId: 11, id: 3, code: 101103, name: "Edwin Fábrega" },
        { provinceId: 10, cantonId: 11, id: 4, code: 101104, name: "La Colorada" },
        { provinceId: 10, cantonId: 11, id: 5, code: 101105, name: "La Peña" },
        { provinceId: 10, cantonId: 11, id: 6, code: 101106, name: "La Raya de Santa María" },
        { provinceId: 10, cantonId: 11, id: 7, code: 101107, name: "Los Algarrobos" },
        { provinceId: 10, cantonId: 11, id: 8, code: 101108, name: "Nuevo Santiago" },
        { provinceId: 10, cantonId: 11, id: 9, code: 101109, name: "Ponuga" },
        { provinceId: 10, cantonId: 11, id: 10, code: 1011010, name: "San Martín de Porres" },
        { provinceId: 10, cantonId: 11, id: 11, code: 1011011, name: "San Pedro del Espino" },
        { provinceId: 10, cantonId: 11, id: 12, code: 1011012, name: "Santiago" },
        { provinceId: 10, cantonId: 11, id: 13, code: 1011013, name: "Santiago Este" },
        { provinceId: 10, cantonId: 11, id: 14, code: 1011014, name: "Santiago Sur" },
        { provinceId: 10, cantonId: 11, id: 15, code: 1011015, name: "Rodrigo Luque" },
        { provinceId: 10, cantonId: 11, id: 16, code: 1011016, name: "Urracá" },

        { provinceId: 10, cantonId: 12, id: 1, code: 101201, name: "Bahía Honda" },
        { provinceId: 10, cantonId: 12, id: 2, code: 101202, name: "Calidonia" },
        { provinceId: 10, cantonId: 12, id: 3, code: 101203, name: "Cativé" },
        { provinceId: 10, cantonId: 12, id: 4, code: 101204, name: "El Marañón" },
        { provinceId: 10, cantonId: 12, id: 5, code: 101205, name: "Guarumal" },
        { provinceId: 10, cantonId: 12, id: 6, code: 101206, name: "Hicaco" },
        { provinceId: 10, cantonId: 12, id: 7, code: 101207, name: "La Soledad" },
        { provinceId: 10, cantonId: 12, id: 8, code: 101208, name: "La Trinchera" },
        { provinceId: 10, cantonId: 12, id: 9, code: 101209, name: "Quebrada de Oro" },
        { provinceId: 10, cantonId: 12, id: 10, code: 1012010, name: "Río Grande" },
        { provinceId: 10, cantonId: 12, id: 11, code: 1012011, name: "Rodeo Viejo" },
        { provinceId: 10, cantonId: 12, id: 12, code: 1012012, name: "Soná" },

        { provinceId: 11, cantonId: 1, id: 1, code: 110101, name: "Ailigandí" },
        { provinceId: 11, cantonId: 1, id: 2, code: 110102, name: "Narganá" },
        { provinceId: 11, cantonId: 1, id: 3, code: 110103, name: "Puerto Obaldía" },
        { provinceId: 11, cantonId: 1, id: 4, code: 110104, name: "Tubualá" },
        { provinceId: 12, cantonId: 1, id: 5, code: 120105, name: "Boca de Balsa" },
        { provinceId: 12, cantonId: 1, id: 6, code: 120106, name: "Cerro Banco" },
        { provinceId: 12, cantonId: 1, id: 7, code: 120107, name: "Cerro Patena" },
        { provinceId: 12, cantonId: 1, id: 8, code: 120108, name: "Camarón Arriba" },
        { provinceId: 12, cantonId: 1, id: 9, code: 120109, name: "Emplanada de Chorcha" },
        { provinceId: 12, cantonId: 1, id: 10, code: 1201010, name: "Nämnoní" },
        { provinceId: 12, cantonId: 1, id: 11, code: 1201011, name: "Niba" },
        { provinceId: 12, cantonId: 1, id: 12, code: 1201012, name: "Soloy" },

        { provinceId: 12, cantonId: 2, id: 1, code: 120201, name: "Burí" },
        { provinceId: 12, cantonId: 2, id: 2, code: 120202, name: "Guariviara" },
        { provinceId: 12, cantonId: 2, id: 3, code: 120203, name: "Man Creek" },
        { provinceId: 12, cantonId: 2, id: 4, code: 120204, name: "Samboa" },
        { provinceId: 12, cantonId: 2, id: 5, code: 120205, name: "Tuwai" },

        { provinceId: 12, cantonId: 3, id: 1, code: 120301, name: "Bisira" },
        { provinceId: 12, cantonId: 3, id: 2, code: 120302, name: "Calante" },
        { provinceId: 12, cantonId: 3, id: 3, code: 120303, name: "Kankintú" },
        { provinceId: 12, cantonId: 3, id: 4, code: 120304, name: "Guoroní" },
        { provinceId: 12, cantonId: 3, id: 5, code: 120305, name: "Mününí" },
        { provinceId: 12, cantonId: 3, id: 6, code: 120306, name: "Piedra Roja" },
        { provinceId: 12, cantonId: 3, id: 7, code: 120307, name: "Tolote" },

        { provinceId: 12, cantonId: 4, id: 1, code: 120401, name: "Bahía Azul" },
        { provinceId: 12, cantonId: 4, id: 2, code: 120402, name: "Cañaveral" },
        { provinceId: 12, cantonId: 4, id: 3, code: 120403, name: "Kusapín" },
        { provinceId: 12, cantonId: 4, id: 4, code: 120404, name: "Río Chiriquí" },
        { provinceId: 12, cantonId: 4, id: 5, code: 120405, name: "Tobobé" },

        { provinceId: 12, cantonId: 5, id: 1, code: 120501, name: "Cascabel" },
        { provinceId: 12, cantonId: 5, id: 2, code: 120502, name: "Hato Corotú" },
        { provinceId: 12, cantonId: 5, id: 3, code: 120503, name: "Hato Culantro" },
        { provinceId: 12, cantonId: 5, id: 4, code: 120504, name: "Hato Pilón" },
        { provinceId: 12, cantonId: 5, id: 5, code: 120505, name: "Hato Jobo" },
        { provinceId: 12, cantonId: 5, id: 6, code: 120506, name: "Hato Julí" },
        { provinceId: 12, cantonId: 5, id: 7, code: 120507, name: "Quebrada de Loro" },
        { provinceId: 12, cantonId: 5, id: 8, code: 120508, name: "Salto Dupí" },

        { provinceId: 12, cantonId: 6, id: 1, code: 120601, name: "Alto Caballero" },
        { provinceId: 12, cantonId: 6, id: 2, code: 120602, name: "Bakama" },
        { provinceId: 12, cantonId: 6, id: 3, code: 120603, name: "Cerro Caña" },
        { provinceId: 12, cantonId: 6, id: 4, code: 120604, name: "Cerro Puerco" },
        { provinceId: 12, cantonId: 6, id: 5, code: 120605, name: "Chichica" },
        { provinceId: 12, cantonId: 6, id: 6, code: 120606, name: "Krüa" },
        { provinceId: 12, cantonId: 6, id: 7, code: 120607, name: "Maraca" },
        { provinceId: 12, cantonId: 6, id: 8, code: 120608, name: "Nibra" },
        { provinceId: 12, cantonId: 6, id: 9, code: 120609, name: "Peña Blanca" },
        { provinceId: 12, cantonId: 6, id: 10, code: 1206010, name: "Roka" },
        { provinceId: 12, cantonId: 6, id: 11, code: 1206011, name: "Sitio Prado" },
        { provinceId: 12, cantonId: 6, id: 12, code: 1206012, name: "Umaní" },
        { provinceId: 12, cantonId: 6, id: 13, code: 1206013, name: "Diko" },
        { provinceId: 12, cantonId: 6, id: 14, code: 1206014, name: "Kikari" },
        { provinceId: 12, cantonId: 6, id: 15, code: 1206015, name: "Dikeri" },
        { provinceId: 12, cantonId: 6, id: 16, code: 1206016, name: "Mreeni" },

        { provinceId: 12, cantonId: 7, id: 1, code: 120701, name: "Cerro Iglesias" },
        { provinceId: 12, cantonId: 7, id: 2, code: 120702, name: "Hato Chamí" },
        { provinceId: 12, cantonId: 7, id: 3, code: 120703, name: "Jädeberi" },
        { provinceId: 12, cantonId: 7, id: 4, code: 120704, name: "Lajero" },
        { provinceId: 12, cantonId: 7, id: 5, code: 120705, name: "Susama" },

        { provinceId: 12, cantonId: 8, id: 1, code: 120801, name: "Agua de Salud" },
        { provinceId: 12, cantonId: 8, id: 2, code: 120802, name: "Alto de Jesús" },
        { provinceId: 12, cantonId: 8, id: 3, code: 120803, name: "Buenos Aires" },
        { provinceId: 12, cantonId: 8, id: 4, code: 120804, name: "Cerro Pelado" },
        { provinceId: 12, cantonId: 8, id: 5, code: 120805, name: "El Bale" },
        { provinceId: 12, cantonId: 8, id: 6, code: 120806, name: "El Paredón" },
        { provinceId: 12, cantonId: 8, id: 7, code: 120807, name: "El Piro" },
        { provinceId: 12, cantonId: 8, id: 8, code: 120808, name: "Guayabito" },
        { provinceId: 12, cantonId: 8, id: 9, code: 120809, name: "Güibale" },
        { provinceId: 12, cantonId: 8, id: 10, code: 1208010, name: "El Peñón" },
        { provinceId: 12, cantonId: 8, id: 11, code: 1208011, name: "El Piro N°2" },

        { provinceId: 12, cantonId: 9, id: 1, code: 120901, name: "Alto Bilingüe" },
        { provinceId: 12, cantonId: 9, id: 2, code: 120902, name: "Loma Yuca" },
        { provinceId: 12, cantonId: 9, id: 3, code: 120903, name: "San Pedrito" },
        { provinceId: 12, cantonId: 9, id: 4, code: 120904, name: "Valle Bonito" },
        { provinceId: 12, cantonId: 9, id: 5, code: 120905, name: "Santa Catalina o Calovébora" },

        { provinceId: 13, cantonId: 1, id: 1, code: 130101, name: "Cirilo Guaynora" },
        { provinceId: 13, cantonId: 1, id: 2, code: 130102, name: "Lajas Blancas" },
        { provinceId: 13, cantonId: 1, id: 3, code: 130103, name: "Manuel Ortega" },

        { provinceId: 13, cantonId: 2, id: 1, code: 130201, name: "Jingurudó" },
        { provinceId: 13, cantonId: 2, id: 2, code: 130202, name: "Río Sabalo" }
    ]
};